import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'

const state = {
  inspect: [], 
}

const getters = {

  inspect(state){
    if(!state.inspect.length || typeof state.inspect[0] === 'undefined')
      return [] 
      
    return state.inspect
  },

  project: (state) => (project) => {
    let employees = []
    let owner = false

    project.useraccess = project.useraccess.filter(function(item) {
      return item !== project.owner
    })

    owner = {id: project.owner, access: 'Eier', ...state.employees.find(user => user.id == project.owner)}

    if(project.useraccess.length){
      project.useraccess.forEach(user => {
        let found = state.employees.find(item => item.id == user)
        if(typeof found !== 'undefined')
          employees.push({...found, id: user, access: 'Tilgang'})
      })
    }

    return [...employees, {...owner}]
  }
}

const mutations = {
  inspect(state, data){
    state.inspect = data
  }
}

const actions = {
  
  update: firestoreAction(({ context }, {employee, data}) => {
    console.log(employee, data)
    console.log(context)
    db.collection('users')
      .doc(employee.id)
      .update(data)
      .then(() => {
      })
  }),
  
  add: firestoreAction(({ context }, user) => {
    console.log(context)
    return fetch('https://us-central1-glor-partner.cloudfunctions.net/dbUsersNewUser', {   
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
            email: user.Email,
            displayName: user.name,
            password: user.password, 
            phone: user.phone,
            worksatcompany: user.worksatcompany
      }),
    })
  }),
  

  inspect: firestoreAction(({ unbindFirestoreRef, bindFirestoreRef, commit }, {id, type}) => {
    if(type == 'all'){
      return bindFirestoreRef('inspect', db.collection('users').where("active", "==", true))
    }
    
    if(type == 'company'){
      return bindFirestoreRef('inspect', db.collection('users').where('worksatcompany', 'array-contains', id).where("active", "==", true))
    }
      
      
    else if(type == 'project'){
      var employees = []
      
      if(typeof id !== 'object')
        id = [id]
        
      console.log('inspect', id)
      if(!id.length)
        return [];
        
      id.forEach(userId => {
          employees.push(db.collection('users').doc(userId).get())
      })
      
      console.log('employees', employees)
      Promise.all(employees).then(items => {
        unbindFirestoreRef('inspect')
        
        items = items.filter(item => !item.active).map(item => item = item.data())
        console.log('items', items)
        commit('inspect', items)
      })
    }
  }),
}


export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}